export const ASO_TEMPLATES = {
    aso: "ASO · Cigna",
    "aso-centivo": "ASO · Centivo",
    "aso-wisconsin": "ASO · Wisconsin",
};

export function isAsoTemplate(templateType) {
    return Object.hasOwn(ASO_TEMPLATES, templateType);
}

export const ASO_PLAN_OFFERING_COPY = {
    "partnership-cigna": "The Partnership Plan will provide your employees with a high-value health plan that offers low, predictable costs when they follow the guidance of their PCP. Partnership Plan members pay an average of only $409 per year in out-of-pocket costs, compared to the national average of over $1,600 per year.",
    "partnership-only": "The Partnership Plan will provide your employees with a high-value health plan that offers low, predictable costs when they follow the guidance of their PCP. Partnership Plan members pay an average of only $409 per year in out-of-pocket costs, compared to the national average of over $1,600 per year.",
};

export const ASO_CIGNA_PPO_COPY = "Centivo can also administer broad network plans using a traditional PPO network, such as Cigna, when employees live outside the Centivo service area. Centivo combines this option along with its Partnership Plan all under one packaged solution.";

export const ASO_STOP_LOSS_ARRANGE_COPY = "If applicable, Centivo will work with you and our preferred partners to arrange for stop loss reinsurance.";
export const ASO_STOP_LOSS_INCLUDED_COPY = "We’ve included a financial exhibit as part of this proposal, with stop-loss quotes for your review.";
export const ASO_STOP_LOSS_PARTNERS_COPY = "Our partners, including both national and regional options, have met Centivo’s standards based on thorough due diligence by Centivo and offer flexible stop loss contracts. Centivo does not receive any financial incentive from these partners. You may substitute an alternate stop loss carrier if you prefer.";
export const ASO_WI_CIGNA_PBM_COPY = "In addition, Centivo offers the Cigna PBM for a more traditional pharmacy solution.";
export const ASO_PROPRIETARY_NETWORK_FALLBACK = "[PROPRIETARY NETWORK IN MARKET NAME]";
export const ASO_WI_PROPRIETARY_NETWORK_FALLBACK = "proprietary networks in Wisconsin";
export const ASO_PROPOSED_PBM_NAME_FALLBACK = "[PROPOSED PBM NAME]";

const DEFAULT_ASO_PRICING = {
    baselineFee: "$60 PEPM",
    escalator: "3.0% per year in years 2 and 3",
    contractTerm: "3 years",
    utilizationManagement: "Included.",
    utilizationManagementNote: "Note: Medical Necessity Reviews performed by our partner, MedWatch, will be charged at an hourly rate of $195/per hour (2026 hourly fee, subject to increase by a small percentage year-over-year).",
    networkAccess: "Cigna network access fee: PPO: $17.19 PEPM.",
    networkAccessNote: "Note: Cigna network access fee only applies for those who elect a plan using the Cigna network. Cigna network access fees will increase year-over-year by 2% or CIPU (whichever is greater).",
    pbmAdminFee: "SmithRx: $10 PMPM pass-through admin fee ($6 for base PBM and $4 for cost management services).\nCapitalRx: $6/script billed as a claim.",
    integrationFees: "Included for stop-loss, eligibility, and Centivo’s preferred PBM partner SmithRx. Additional client-specific integrations to be scoped and additional pricing may apply.",
    integrationFeesNote: "*Other PBM partners: $5 PEPM + vendor fees (pass through)",
    commissions: "Not included but can pass-through commissions by request.",
    offEffectiveDate: "Customization fee subject to scope due to accumulator and other impacts",
    caseManagement: "$195/hour through MedWatch (included in claims cost).",
    caseManagementNote: "Note: Pricing based on 2026 costs. Fees subject to increase by a small percent year-over-year.",
    virtualCareCentivo: "Included standardly as an in-network primary care option for all adult members enrolled in the Centivo Partnership Plan. $45 PPPM (per patient per month) capitation for virtual primary and urgent care and is billed as a claim for those patients who activate or are defaulted into Centivo Care as their Primary Care Team. The $45 PPPM includes the $3 PMPM below for telemedicine.",
    virtualCareTelemedicine: "Included standardly for all members, MDLIVE will deliver 24/7/365 virtual urgent care in 50 states to all enrolled members. $3 PMPM (per member per month) applied to all enrolled members in partnership and non-partnership plans, processed as a claim. For non-Centivo Care patients, there is a $30 visit cost.",
    idCards: "Includes 1 for subscriber only, 2 for family. Global reprints of ID cards will be billed at $7/employee.",
    customCommunications: "Custom communications to be priced based on scope (i.e., custom communications throughout the year, translation and printing, custom ID cards, etc.)",
    additionalServices: "Pricing for COBRA administration, pre-tax accounts and/or other products/services available upon request.",
    medicalSpecialtyRx: "",
    baselineFeeLt151: "",
    baselineFee151to300: "",
    baselineFee301to1k: "",
    baselineFee1kto25k: "",
    baselineFee25kPlus: "",
    successFee: "",
    planDesignFee: "",
    networkAccessHps: "",
    networkAccessCigna: "",
    networkAccessCignaNote: "",
    networkAccessPhcs: "",
    providerVbp: "",
    complianceSupport: "",
    complianceSupportNote: "",
    bhcgMembershipFee: "",
};

const ASO_CENTIVO_PRICING = {
    baselineFee: "$53 PEPM",
    networkAccess: "Centivo proprietary network: $20 PEPM",
    networkAccessNote: "",
    integrationFees: "Included for stop-loss, eligibility, and Centivo’s preferred PBM partner(s), SmithRx and CapitalRx*. Additional client-specific integrations to be scoped and additional pricing may apply.",
    medicalSpecialtyRx: "$0.90 PMPM",
};

const ASO_WISCONSIN_PRICING = {
    utilizationManagement: "Included",
    utilizationManagementNote: "Note: Medical Necessity Reviews will be charged at an hourly rate of $140/per hour (2024 hourly fee, subject to increase by a small percentage year-over-year).",
    networkAccess: "Centivo proprietary network: Included",
    networkAccessNote: "",
    pbmAdminFee: "Preferred PBM Partners:\nSmithRx: $10 PMPM pass-through admin fee (for base PBM for cost management services)\n\nCapitalRx: $6 per script, billed as a claim",
    medicalSpecialtyRx: "$0.90 PMPM",
    integrationFees: "Included: Stop-loss, eligibility, Artemis and one (1) additional integration at client discretion; $5,000/integration thereafter.",
    integrationFeesNote: "",
    idCards: "Includes 1 for subscriber only, 2 for family. Global reprints of ID cards will be billed at $2.50/employee.",
    additionalServices: "Pricing for COBRA administration, pre-tax accounts, subrogation, wrap network charges, and/or other products/services available upon request",
    baselineFeeLt151: "$46.35",
    baselineFee151to300: "$41.20",
    baselineFee301to1k: "$38.11",
    baselineFee1kto25k: "$30.90",
    baselineFee25kPlus: "$25.75",
    successFee: "For clients enrolled in WI-1: Centivo earns 25% of savings starting with the first dollar saved\n\nFor clients enrolled in WI-2: Centivo earns 25% of savings once savings of 4% are achieved.\n\nSuccess fee details are outlined in the appendix of this proposal.",
    planDesignFee: "Up to 3 plans included; each incremental plan costs $5,000 each",
    networkAccessHps: "HPS fee (Wisconsin population):\n$8.50 PEPM for Network Access\n0.8% of Allowed Single Payment System (SPS) Fee for PayMedix Financial Tools",
    networkAccessCigna: "Cigna fee (non-Wisconsin population):\n2026 Rates: (effective fees for 1/1/26–12/31/26)\nPPO: $17.19 PEPM\nEPO: $17.19 PEPM\nOAP: $20.35 PEPM\nLocalPlus: $16.85 PEPM",
    networkAccessCignaNote: "Note: Cigna network access fees will increase year-over-year by 2% or CIPU (whichever is greater)",
    networkAccessPhcs: "PHCS network access fee:\n$5.20 PEPM",
    providerVbp: "Paid via claims",
    complianceSupport: "Basic: $1.00 PPPM\nEnhanced: $8.25 PEPM (see appendix for details)",
    complianceSupportNote: "Federal regulatory compliance support for Transparency in Coverage (TiC) and Consolidated Appropriations Act (CAA) requirements including Plan Sponsor-Specific Machine Readable Files (MRF) and assistance to Plan Sponsor regarding compliance with all other ongoing and new regulations and legislative changes that pertain to Administrator’s responsibilities.",
    bhcgMembershipFee: "In order to offer the BHCG-Centivo solution, employers with a physical presence in Wisconsin must be BHCG members. The membership fee is $15 PEPY for each eligible employee located in Wisconsin and $15 PEPY for each enrolled subscriber outside of Wisconsin.\n\nEmployers with no physical presence in Wisconsin must pay a fee of $15 PEPY for those employees who enroll in the High-Performance Health Plan / access the proprietary network in Wisconsin.",
};

export function getDefaultAsoPricing(templateType) {
    if (templateType === "aso-centivo") return { ...DEFAULT_ASO_PRICING, ...ASO_CENTIVO_PRICING };
    if (templateType === "aso-wisconsin") return { ...DEFAULT_ASO_PRICING, ...ASO_WISCONSIN_PRICING };
    return { ...DEFAULT_ASO_PRICING };
}

function hasText(pricing, keys) {
    return keys.some((key) => String(pricing[key] ?? "").trim() !== "");
}

export function getAsoPricing(value, templateType) {
    const incoming = value && typeof value === "object" ? value : {};
    const defaults = getDefaultAsoPricing(templateType);
    const out = {};
    for (const key of Object.keys(defaults)) {
        if (incoming[key] == null) out[key] = defaults[key];
        else {
            const raw = String(incoming[key]);
            out[key] = raw.trim() ? raw : "";
        }
    }
    const has = (...keys) => hasText(out, keys);
    out.showBaselineFees = has("baselineFeeLt151", "baselineFee151to300", "baselineFee301to1k", "baselineFee1kto25k", "baselineFee25kPlus");
    out.showUtilizationManagement = has("utilizationManagement", "utilizationManagementNote");
    out.showNetworkAccess = has("networkAccess", "networkAccessNote", "networkAccessHps", "networkAccessCigna", "networkAccessCignaNote", "networkAccessPhcs");
    out.showIntegrationFees = has("integrationFees", "integrationFeesNote");
    out.showCaseManagement = has("caseManagement", "caseManagementNote");
    out.showVirtualCare = has("virtualCareCentivo", "virtualCareTelemedicine");
    out.showComplianceSupport = has("complianceSupport", "complianceSupportNote");
    out.showCoreAdminFees = has("baselineFee", "escalator", "contractTerm", "utilizationManagement", "utilizationManagementNote", "networkAccess", "networkAccessNote", "pbmAdminFee", "medicalSpecialtyRx", "integrationFees", "integrationFeesNote", "commissions", "offEffectiveDate");
    out.showClaimsFees = has("caseManagement", "caseManagementNote", "virtualCareCentivo", "virtualCareTelemedicine");
    out.showOptionalServices = has("idCards", "customCommunications", "additionalServices");
    out.showWiCoreFees = has("baselineFeeLt151", "baselineFee151to300", "baselineFee301to1k", "baselineFee1kto25k", "baselineFee25kPlus", "successFee", "contractTerm", "planDesignFee", "utilizationManagement", "utilizationManagementNote", "caseManagement", "caseManagementNote");
    out.showWiContinuedFees = has("networkAccess", "networkAccessHps", "networkAccessCigna", "networkAccessCignaNote", "networkAccessPhcs", "pbmAdminFee", "medicalSpecialtyRx", "providerVbp", "additionalServices", "integrationFees", "idCards", "customCommunications");
    out.showWiPricingFees = has("virtualCareCentivo", "virtualCareTelemedicine", "complianceSupport", "complianceSupportNote", "commissions", "offEffectiveDate", "bhcgMembershipFee");
    return out;
}

export const ASO_PRICING_FIELDS = [
    { key: "baselineFee", label: "Baseline administrative fee", templates: ["aso", "aso-centivo"] },
    { key: "baselineFeeLt151", label: "Baseline fee — under 151", templates: ["aso-wisconsin"] },
    { key: "baselineFee151to300", label: "Baseline fee — 151–300", templates: ["aso-wisconsin"] },
    { key: "baselineFee301to1k", label: "Baseline fee — 301–1,000", templates: ["aso-wisconsin"] },
    { key: "baselineFee1kto25k", label: "Baseline fee — 1,000–2,500", templates: ["aso-wisconsin"] },
    { key: "baselineFee25kPlus", label: "Baseline fee — 2,500+", templates: ["aso-wisconsin"] },
    { key: "successFee", label: "Success fee", templates: ["aso-wisconsin"] },
    { key: "escalator", label: "Annual escalator", templates: ["aso", "aso-centivo"] },
    { key: "contractTerm", label: "Contract term" },
    { key: "planDesignFee", label: "Plan design", templates: ["aso-wisconsin"] },
    { key: "utilizationManagement", label: "Utilization management" },
    { key: "utilizationManagementNote", label: "Utilization management note" },
    { key: "networkAccess", label: "Network access" },
    { key: "networkAccessNote", label: "Network access note", templates: ["aso", "aso-centivo"] },
    { key: "networkAccessHps", label: "Network access — HPS", templates: ["aso-wisconsin"] },
    { key: "networkAccessCigna", label: "Network access — Cigna", templates: ["aso-wisconsin"] },
    { key: "networkAccessCignaNote", label: "Cigna network access note", templates: ["aso-wisconsin"] },
    { key: "networkAccessPhcs", label: "Network access — PHCS", templates: ["aso-wisconsin"] },
    { key: "pbmAdminFee", label: "Transparent PBM admin fee" },
    { key: "medicalSpecialtyRx", label: "Medical Specialty Rx", templates: ["aso-centivo", "aso-wisconsin"] },
    { key: "providerVbp", label: "Provider value-based payments", templates: ["aso-wisconsin"] },
    { key: "integrationFees", label: "Integration fees" },
    { key: "integrationFeesNote", label: "Integration fees note", templates: ["aso", "aso-centivo"] },
    { key: "commissions", label: "Consultant or broker commissions" },
    { key: "offEffectiveDate", label: "Off-effective date changes" },
    { key: "caseManagement", label: "Case management" },
    { key: "caseManagementNote", label: "Case management note" },
    { key: "virtualCareCentivo", label: "Virtual care — Centivo Care" },
    { key: "virtualCareTelemedicine", label: "Virtual care — Telemedicine" },
    { key: "complianceSupport", label: "Federal regulatory and compliance", templates: ["aso-wisconsin"] },
    { key: "complianceSupportNote", label: "Compliance support note", templates: ["aso-wisconsin"] },
    { key: "bhcgMembershipFee", label: "BHCG membership fee", templates: ["aso-wisconsin"] },
    { key: "idCards", label: "ID Cards" },
    { key: "customCommunications", label: "Custom communications" },
    { key: "additionalServices", label: "Additional services" },
];

export function pricingFieldsFor(templateType) {
    return ASO_PRICING_FIELDS.filter((field) => !field.templates || field.templates.includes(templateType));
}

const CIGNA_FEES = [
    "baselineFee",
    "escalator",
    "contractTerm",
    "utilizationManagement",
    "utilizationManagementNote",
    "networkAccess",
    "networkAccessNote",
    "pbmAdminFee",
    "integrationFees",
    "integrationFeesNote",
    "commissions",
    "offEffectiveDate",
    "caseManagement",
    "caseManagementNote",
    "virtualCareCentivo",
    "virtualCareTelemedicine",
    "idCards",
    "customCommunications",
    "additionalServices",
];

const CENTIVO_FEES = [
    "baselineFee",
    "escalator",
    "contractTerm",
    "utilizationManagement",
    "utilizationManagementNote",
    "networkAccess",
    "networkAccessNote",
    "pbmAdminFee",
    "medicalSpecialtyRx",
    "integrationFees",
    "integrationFeesNote",
    "commissions",
    "offEffectiveDate",
    "caseManagement",
    "caseManagementNote",
    "virtualCareCentivo",
    "virtualCareTelemedicine",
    "idCards",
    "customCommunications",
    "additionalServices",
];

const WISCONSIN_FEES = [
    "baselineFeeLt151",
    "baselineFee151to300",
    "baselineFee301to1k",
    "baselineFee1kto25k",
    "baselineFee25kPlus",
    "successFee",
    "contractTerm",
    "planDesignFee",
    "utilizationManagement",
    "utilizationManagementNote",
    "caseManagement",
    "caseManagementNote",
    "networkAccess",
    "networkAccessHps",
    "networkAccessCigna",
    "networkAccessCignaNote",
    "networkAccessPhcs",
    "pbmAdminFee",
    "medicalSpecialtyRx",
    "providerVbp",
    "additionalServices",
    "integrationFees",
    "idCards",
    "customCommunications",
    "virtualCareCentivo",
    "virtualCareTelemedicine",
    "complianceSupport",
    "complianceSupportNote",
    "commissions",
    "offEffectiveDate",
    "bhcgMembershipFee",
];

/** Sidebar controls in the same order as the preview, top to bottom. */
export const ASO_SIDEBAR_ORDER = {
    aso: [
        "companyName",
        "proposalDate",
        "openingSentence",
        "planOffering",
        "workbook",
        "pricingHeading",
        "proprietaryNetwork",
        ...CIGNA_FEES,
        "pricingHint",
        "illustrative",
        "equivalents",
        "proposedPbmName",
        "stopLoss",
    ],
    "aso-centivo": [
        "companyName",
        "proposalDate",
        "openingSentence",
        "workbook",
        "pricingHeading",
        "proprietaryNetwork",
        ...CENTIVO_FEES,
        "pricingHint",
        "illustrative",
        "equivalents",
        "proposedPbmName",
        "stopLoss",
    ],
    "aso-wisconsin": [
        "companyName",
        "employeeTerm",
        "proposalDate",
        "openingSentence",
        "solution",
        "cignaFootprint",
        "workbook",
        "networkAccessPage",
        "geoAccess",
        "pricingHeading",
        "proprietaryNetwork",
        ...WISCONSIN_FEES,
        "pricingHint",
        "illustrative",
        "equivalents",
        "cignaPbm",
        "stopLossQuotes",
        "stopLoss",
    ],
};

export function sidebarOrder(templateType) {
    return ASO_SIDEBAR_ORDER[templateType] || ASO_SIDEBAR_ORDER.aso;
}

export function employeeTerms(value) {
    const asoEmployeeTerm = String(value || "").trim() || "employees";
    const lower = asoEmployeeTerm.toLowerCase();
    let singular = asoEmployeeTerm;
    if (lower === "employees") singular = "employee";
    else if (lower.endsWith("ies") && asoEmployeeTerm.length > 3) singular = `${asoEmployeeTerm.slice(0, -3)}y`;
    else if (lower.endsWith("s") && !lower.endsWith("ss") && asoEmployeeTerm.length > 1) singular = asoEmployeeTerm.slice(0, -1);
    return { asoEmployeeTerm, asoEmployeeTermSingular: singular };
}
